export const EVALUATE_PROGRESS_STATUS_MUTATION = "EVALUATE_PROGRESS_STATUS_MUTATION";
